<template>
  <q-form @submit="onSubmit" ref="myForm" class="flexbox">
    <div class="q-pa-md">
      <div class="row q-col-gutter-xs">
        <div class="col-md-4 col-xs-12 col-lg-4 col-xl-4">
          <span class="label-input">State*</span>
          <q-select
            class="customTextColor"
            outlined
            color="grey-7"
            label-color="grey-7"
            lazy-rules
            :options="countries"
            :placeholder="placeholderGenerator(state, 'Select State')"
            map-options
            emit-value
            use-input
            @filter="filterCountries"
            option-label="name"
            option-value="id"
            v-model="state"
          >
            <template v-slot:no-option>
              <q-item>
                <q-item-section class="text-italic text-grey">
                  There is no options.
                </q-item-section>
              </q-item>
            </template>
            <template v-slot:prepend>
              <q-icon name="fas fa-flag" size="16px" color="grey-7"></q-icon>
            </template>
            <template v-slot:append>
              <q-icon
                name="fas fa-times"
                @click.stop="state = null"
                class="cursor-pointer"
                color="grey-7"
                size="16px"
              />
            </template>
          </q-select>
        </div>
        <div class="col-md-4 col-xs-12 col-lg-4 col-xl-4">
          <span class="label-input">City*</span>
          <q-select
            class="customTextColor"
            :disable="loadingCities"
            outlined
            :options="cities"
            ref="city"
            :placeholder="placeholderGenerator(city, 'Select City')"
            color="grey-7"
            label-color="grey-7"
            lazy-rules
            @filter="filterCities"
            :loading="loadingCities"
            option-label="name"
            option-value="id"
            v-model="city"
            map-options
            emit-value
            use-input
          >
            <template v-slot:no-option>
              <q-item>
                <q-item-section class="text-italic text-grey">
                  There is no options.
                </q-item-section>
              </q-item>
            </template>
            <template v-slot:prepend>
              <q-icon name="fas fa-city" size="16px" color="grey-7"></q-icon>
            </template>
            <template v-slot:append>
              <q-icon name="fas fa-times" @click.stop="city = null" class="cursor-pointer" color="grey-7" size="16px" />
            </template>
          </q-select>
        </div>
        <div class="col-md-4 col-xs-12 col-lg-4 col-xl-4">
          <span class="label-input">ZIP Code*</span>
          <q-input
            type="number"
            outlined
            lazy-rules
            v-model="zip"
            placeholder="Type yor zip code"
            color="grey-7"
            label-color="grey-7"
          >
            <template v-slot:prepend>
              <q-icon name="fas fa-at" size="16px" color="grey-7"></q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-12 col-xs-12 col-lg-12">
          <span class="label-input">Address*</span>
          <q-input
            class="customTextColor"
            type="textarea"
            ref="email"
            outlined
            lazy-rules
            v-model="address"
            placeholder="Type your address"
            color="grey-7"
            label-color="grey-7"
          >
            <template v-slot:prepend>
              <q-icon name="fas fa-map-marker-alt" size="16px" color="grey-7"></q-icon>
            </template>
          </q-input>
        </div>
        <div class="mt-5 flex-end q-gutter-xs">
          <q-btn @click="reset" color="grey-7" label="Cancel"></q-btn>
          <q-btn :loading="loading" label="Save" type="submit" color="positive">
            <template v-slot:loading>
              <q-spinner-facebook />
            </template>
          </q-btn>
        </div>
      </div>
    </div>
  </q-form>
</template>

<script>
import axios from '../axios/index'
export default {
  data() {
    return {
      loading: false,
      loadingCities: false,
      zip: this.$store.state.profile.user.zip,
      city: this.$store.state.profile.user.city,
      state: this.$store.state.profile.user.state,
      address: this.$store.state.profile.user.address,
      cloneUser: { ...this.$store.state.profile.user },
      states: [],
      cityByState: [],
      cities: [],
      countries: []
    }
  },
  async created() {
    await this.getStates()
    if (this.$store.state.profile.user.state.id) await this.getCities(this.$store.state.profile.user.state.id)
  },
  methods: {
    placeholderGenerator(val, text) {
      const typeOfValue = typeof val
      if (typeOfValue === 'string') {
        return val ? '' : text
      } else if (typeOfValue === 'object') {
        return val?.id ? '' : text
      }
    },
    filterCountries(val, update, abort) {
      update(() => {
        const needle = val.toLowerCase()
        this.countries = this.states.filter(v => v.name.toLowerCase().indexOf(needle) > -1)
      })
    },
    filterCities(val, update, abort) {
      update(() => {
        const needle = val.toLowerCase()
        this.cities = this.cityByState.filter(v => v.name.toLowerCase().indexOf(needle) > -1)
      })
    },
    reset() {
      this.city = { ...this.$store.state.profile.user.city }
      this.state = { ...this.$store.state.profile.user.state }
      this.address = this.$store.state.profile.user.address
      this.$refs.myForm.resetValidation()
    },
    async getCities(id) {
      try {
        const { data } = await axios.get(`cities/${id}`)
        this.cityByState = data.data
        this.$store.commit('profile/SET_CITIES', data.data)
      } catch (error) {
      } finally {
      }
    },
    async getStates() {
      try {
        this.loadingCities = true
        const { data } = await axios.get('states')
        this.$store.commit('profile/SET_COUNTRIES', data.data)
        this.states = data.data
        this.countries = data.data
      } catch (error) {
      } finally {
        this.loadingCities = false
      }
    },
    async onSubmit() {
      try {
        this.loading = true
        const { email, last_name, name, id } = this.cloneUser
        let city = null
        let state = null
        if (this.city) {
          typeof this.city === 'string' ? (city = this.city) : (city = this.city.id)
        }
        if (this.state) {
          typeof this.state === 'string' ? (state = this.state) : (state = this.state.id)
        }
        const body = {
          email,
          last_name: last_name,
          name,
          city,
          state,
          address: this.address,
          zip: this.zip
        }
        const { data } = await axios.patch('profile', body)
        this.$store.commit('profile/SET_USER', {
          id,
          email,
          last_name,
          name,
          city: this.cityByState.find(item => item.id === this.city),
          state: this.countries.find(item => item.id === this.state),
          address: this.address,
          zip: this.zip
        })
        this.$q.notify({
          message: data.message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
      } catch (error) {
        const { message } = error.response.data
        this.$q.notify({
          message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
        this.reset()
      } finally {
        this.loading = false
      }
    }
  },
  computed: {
    user: {
      get() {
        return this.$store.state.profile.user
      },
      set(val) {
        this.$store.commit('profile/SET_USER', val)
      }
    }
  },
  watch: {
    state: {
      deep: true,
      handler(n, o) {
        if (n) {
          this.getCities(n)
          if (this.$store.state.profile.user.state.id !== n) {
            this.city = null
            this.getStates()
          }
          this.$refs.city.resetValidation()
        } else {
          this.getStates()
          this.cities = []
          this.city = null
        }
      }
    }
  }
}
</script>
